/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useState } from 'react';
import {
  Grid,
  Table,
  TableHeaderRow,
  TableEditColumn,
} from '@devexpress/dx-react-grid-material-ui';
import { Box, fade, Paper, Typography, withStyles } from '@material-ui/core';
import { DataTypeProvider, EditingState } from '@devexpress/dx-react-grid';
import { CommandSmall } from './CommandSmall';
import { Getter } from '@devexpress/dx-react-core';
import PopupEditing from './PopupEditing';
import PopupItem from '../pubups/PopupItem';
import { getColumns } from '../common/columns';
import { useTemplate } from '../hooks';
import { currencyFormatter, quantityFormatter } from './colorFormat';
import useWindowDimensions from '../hooks/useWindowDimensions';

export const getRowId = (row: any) => row.index;

const IndexProvider = (props) => (
  <DataTypeProvider
    formatterComponent={({ value }) => (
      <Typography variant="subtitle2">{Number(value) + 1}</Typography>
    )}
    {...props}
  />
);

const styles = (theme) => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: fade(theme.palette.primary.main, 0.1),
    },
  },
});

const TableComponentBase = ({ classes, ...restProps }) => (
  <Table.Table {...restProps} className={classes.tableStriped} />
);

export const TableComponent = withStyles(styles, { name: 'TableComponent' })(
  TableComponentBase
);

export default function ItemsTable({
  rows,
  removeItem,
  editItem,
  isRTL,
  words,
  user,
  height = 200,
  products,
  itemrelations,
  noprice,
}: any) {
  const col = getColumns({ isRTL, words });
  const { tempoptions } = useTemplate();
  const { isMobile } = useWindowDimensions();
  const [columns] = useState(
    [
      { name: 'index', title: words.no },
      tempoptions?.category && col.category,
      { name: isRTL ? 'nameAr' : 'name', title: words.item },
      tempoptions?.itemdescription && {
        name: 'note',
        title: words.description,
      },
      tempoptions?.contract && col.contract,
      tempoptions?.employee && itemrelations && col.employee,
      tempoptions?.department && itemrelations && col.department,
      tempoptions?.resourse && itemrelations && col.resourse,
      { name: 'itemqty', title: words.qty },
      { name: 'itemprice', title: words.theprice },
      { name: 'itemtotal', title: words.total },
    ].filter((x) => x)
  );

  const [tableColumnExtensions]: any = useState([
    { columnName: 'index', width: 50 },
    { columnName: col.category.name, width: 100 },
    { columnName: 'name', width: 150 },
    { columnName: 'note', width: 'auto' },
    { columnName: col.contract.name, width: 100 },
    { columnName: col.department.name, width: 100 },
    { columnName: col.employee.name, width: 100 },
    { columnName: col.resourse.name, width: 100 },
    { columnName: 'itemqty', width: 70 },
    { columnName: 'itemprice', width: 120 },
    { columnName: 'itemtotal', width: 150 },
  ]);

  const commitChanges = async ({ deleted }) => {
    if (deleted) {
      const index = deleted[0];
      removeItem(index);
    }
  };

  const renderEmpty = () => {
    return <Box display="flex"></Box>;
  };

  const addAction = () => {
    //
  };

  return (
    <Paper
      style={{
        overflow: 'auto',
        margin: 10,
        height,
      }}
    >
      {rows && (
        <Grid rows={rows} columns={columns} getRowId={getRowId}>
          <EditingState onCommitChanges={commitChanges} />

          <Table
            noDataCellComponent={renderEmpty}
            columnExtensions={tableColumnExtensions}
            tableComponent={TableComponent}
          />
          <TableHeaderRow
            titleComponent={({ children }) => {
              return (
                <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                  {children}
                </Typography>
              );
            }}
          />
          <IndexProvider for={['index']} />
          <DataTypeProvider
            for={['itemtotal', 'itemprice']}
            formatterComponent={currencyFormatter}
          ></DataTypeProvider>
          <DataTypeProvider
            for={['itemqty']}
            formatterComponent={quantityFormatter}
          ></DataTypeProvider>
          <TableEditColumn
            showDeleteCommand
            showEditCommand
            commandComponent={CommandSmall}
          ></TableEditColumn>
          <PopupEditing addAction={addAction} editAction={editItem}>
            <PopupItem
              products={products}
              user={user}
              isRTL={isRTL}
              words={words}
              itemrelations={itemrelations}
            ></PopupItem>
          </PopupEditing>
          <Getter
            name="tableColumns"
            computed={({ tableColumns }) => {
              const result = [
                {
                  key: 'editCommand',
                  type: TableEditColumn.COLUMN_TYPE,
                  width: isMobile ? 100 : 120,
                },
                ...tableColumns.filter(
                  (c: any) => c.type !== TableEditColumn.COLUMN_TYPE
                ),
              ];
              return result;
            }}
          />
        </Grid>
      )}
    </Paper>
  );
}
